import { module } from 'modujs';

const CLASS = {
    HIDDEN: `is-hidden`
}

export default class extends module {
    constructor(m) {
        super(m);
        this.player;
        this.iframeEmbed = this.$('iframe')[0];

        this.playBtn = document.querySelector('[data-player="play"]');
        this.pauseBtn = document.querySelector('[data-player="pause"]');
        this.closeBtn = document.querySelector('[data-player="close"]');

        let player = document.querySelector('.c-player');

        this.playlists = document.querySelectorAll('.c-playlist_li');

        this.playlists_ids = [this.playlists[0].dataset.playlistId, this.playlists[1].dataset.playlistId]

        this.playlists.forEach(playlist => {
            playlist.addEventListener('click', () => {
                this.player.stopVideo();

                let playlist_id = playlist.dataset.playlistId;

                setTimeout(() => {
                    this.player.loadPlaylist({ 'listType': 'playlist', 'list': playlist_id, 'index': Math.floor(Math.random() * 16) });

                    if (this.pauseBtn.classList.contains(CLASS.HIDDEN) && this.el.classList.contains(CLASS.HIDDEN)) {
                        this.el.classList.remove(CLASS.HIDDEN)
                        this.playBtn.classList.add(CLASS.HIDDEN)
                        this.pauseBtn.classList.remove(CLASS.HIDDEN)
                    }
                }, 100)
            })
        })

        this.playBtn.addEventListener('click', () => {
            this.player.playVideo()
            this.playBtn.classList.add(CLASS.HIDDEN)
            this.pauseBtn.classList.remove(CLASS.HIDDEN)

            setTimeout(() => {
                this.el.classList.remove(CLASS.HIDDEN)
            }, 3000)
        })

        this.pauseBtn.addEventListener('click', () => {
            this.el.classList.add(CLASS.HIDDEN)
            this.playBtn.classList.remove(CLASS.HIDDEN)
            this.pauseBtn.classList.add(CLASS.HIDDEN)

            setTimeout(() => {
                this.player.pauseVideo()
            }, 300)
        })

        this.el.addEventListener('mouseenter', () => {
            player.classList.add('is-big')
        })

        this.closeBtn.addEventListener('click', () => {
            this.el.classList.remove('is-big')
        })
    }

    init() {
        let tag = document.createElement('script');
        tag.src = "https://www.youtube.com/player_api";
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        setTimeout(() => {
            this.player = new YT.Player(this.iframeEmbed, {
                height: '100%',
                width: '100%',
                playerVars: {
                    'autoplay': 0,
                    'controls': 0,
                    'playsinline': 1,
                    'autohide': 1,
                    'modestbranding': 1,
                    'rel': 0,
                    'showInfo': 0,
                    'loop': 1,
                    'fs': 0,
                    'iv_load_policy': 3,
                    'wmode': 'opaque',
                    'list_type': 'playlist',
                    'list': this.playlists[0].dataset.playlistId,
                    'index': Math.floor(Math.random() * 16)
                }
            });
        }, 100)
    }

    playVideo() {
        this.player.playVideo();

    }

    pauseVideo() {
        this.player.pauseVideo();

    }
}
